import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string } from 'prop-types'

import { Chevron } from '../svgs/Chevron'
import ContentContainer from '../ContentContainer'

const DrawerWrapper = styled.div`
	border-top: ${({ theme }) => theme.borders.secondary};
	margin: auto;
	width: 90%;
	${({ theme }) => theme.MQ.M} {
		width: 100%;
	}
`
const Title = styled.h2`
	${({ theme }) => theme.header.h2};
	color: ${({ theme }) => theme.bestPicks.sectionTitleColor};
	font-size: 16px;

	${({ theme }) => theme.MQ.M} {
		font-size: 25px;
	}
`
const Drawer = styled.div`
	align-items: center;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	width: 100%;
`
const Arrow = styled.div`
	transform: ${({ isDrawerOpen }) => (isDrawerOpen ? `rotate(180deg)` : `rotate(90deg)`)};
	height: 13px;
	max-width: 13px;
	width: 100%;
`
const ContainerDrawer = styled.div`
	display: ${({ isDrawerOpen }) => (isDrawerOpen ? `block` : `none`)};

	h3 {
		color: ${({ theme }) => theme.bestPicks.altSectionTitleColor};
	}
`
ContentDrawer.propTypes = {
	text: string.isRequired,
	title: string.isRequired,
}
/**
 * Content that can be hidden by a drawer that toggles when clicked
 * @param {String} props.text :: context that should display within the drawer
 * @param {String} props.title :: title of the section
 */
export function ContentDrawer({ text, title }) {
	const [isOpen, setIsOpen] = useState(true)
	const {
		bestPicks: { chevronColor },
	} = useTheme()

	return (
		<DrawerWrapper>
			<Drawer onClick={() => setIsOpen(!isOpen)}>
				<Title>{title}</Title>
				<Arrow isDrawerOpen={isOpen}>
					<Chevron color={chevronColor} strokeWidth={3} />
				</Arrow>
			</Drawer>
			<ContainerDrawer isDrawerOpen={isOpen}>
				<ContentContainer content={text} />
			</ContainerDrawer>
		</DrawerWrapper>
	)
}
